/**
 * Trims a string
 *
 * @param  {string} value
 * @returns {string}
 */
export const trimString = value => (value && typeof value === 'string' ? value.trim() : value);
